import { useState, useEffect, useMemo } from "react";

import styled from "styled-components";



import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";


import logo1 from "./logo-1.png";
import logo6 from "./logo-6.png";

import { ImArrowLeft, ImArrowRight } from "react-icons/im";

const Geral = styled.div`
  max-width: 100%;
  overflow: auto;
  
  background-color: transparent;
  border-radius: 12px;
  box-shadow: 0px 0px 2px #ccc;


  @media (max-width:1367px) {
    margin: 5px;
    box-shadow: none;

  }

  @media (max-width: 1024px) {
    margin: 5px;
    box-shadow: none;
    margin-bottom: 100px;
  }


`;


const Table = styled.table`
  border-collapse: collapse;
  width: 100%;
  font-family: 'Roboto', sans-serif;
  
  
`;

const Thead = styled.thead`
  background-color: #fff;

`;


export const Tbody = styled.tbody`
  background-color: #fefefe;
`;

export const Tr = styled.tr`
  border-bottom: 1px solid #e0e0e0;
  
  ${({ noHover }) =>
    !noHover &&
    `
    &:hover {
      background-color: #f5f5f5;
    }
  `}

  @media (max-width: 1024px) {
    .hide-on-mobile {
      display: none;
    }
  }
`;

export const TrHead = styled.tr`
  border-bottom: 1px solid #e0e0e0;
  

  @media (max-width: 1024px) {
    .hide-on-mobile {
      display: none;
    }
  }
`;

export const Th = styled.th`
  color: #575757;
  padding: 18px 10px;
  font-size: 14px;
  text-align: center;
  font-weight: bold;

  cursor: pointer;
  &.hide-on-mobile {
    @media (max-width: 1024px) {
      display: none;
    }
  }





  @media (max-width: 1367px) {
    padding: 6px 5px;
    font-size: 12px;
  }
  @media (max-width: 1024px) {
    padding: 6px 5px;
    font-size: 12px;
  }

  @media (max-width: 780px) {
    padding: 6px 1px;
    font-size: 6px;
  }
`;



export const Td = styled.td`
  padding: 25px 10px;

  font-size: 16px;
  color: #575757;
  background-color: ${(props) => props.zebra ? "#f2f2f2" : "transparent"};
    text-align: center;
  white-space: nowrap; 
  overflow: hidden;     
  text-overflow: ellipsis; 

  &.mobile-hide {
    @media (max-width: 1024px) {
      display: none;
    }
  }
  @media (max-width: 1367px) {
    padding: 6px;
    font-size: 14px;
  }

  @media (max-width: 1024px) {
    padding: 6px;
    font-size: 12px;
  }

  @media (max-width: 780px) {
    padding: 6px 1px;
    font-size: 6px;
  }

`;

export const CabecalhoTabela = styled.th`
  text-align: center;
  
  padding: 18px;
  color: white;

  h2{
    font-size: 2rem;
  }

  padding{
    font-size: 1.4rem;
  }

  
`;

const Button = styled.button`
  background-color: #E5F7EE; // verde claro pastel
  color: #008000;            // verde forte
  font-size: 16px;
  font-weight: 600;
  padding: 8px 16px;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  transition: background 0.2s ease;

  &:hover {
    background-color: #d3f0e2; // tom mais escuro no hover
  }

  @media (max-width: 780px) {
    font-size: 14px;
    padding: 6px 12px;
  }
`;

const Button2 = styled.button`
  background-color: transparent; // verde claro pastel
  color: #575757;            // verde forte
  font-size: 16px;
  font-weight: 600;
  padding: 8px 16px;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  transition: background 0.2s ease;

  &:hover {
    background-color: #d3f0e2; // tom mais escuro no hover
  }

  @media (max-width: 780px) {
    font-size: 14px;
    padding: 6px 12px;
  }
`;

const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;


  h2 {
    margin: 0;
    font-size: 32px;
    color: #008000;
  }

  @media (max-width: 780px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;

    h2 {
      font-size: 20px;
    }
  }
`;



const HeaderRight = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;

  @media (max-width: 780px) {
    width: 100%;
    display: flex;
    justify-content: space-between;

    p {
      font-size: 10px;
    }
  }
`;
const IconGroup = styled.div`
  display: flex;
  gap: 5px;
  align-items: center;
`;

const LoadingMessage = styled.p`
  font-size: 18px;
  font-weight: 500;
  color: #555;
  text-align: center;
  margin: 30px;

  &::after {
    content: '';
    display: inline-block;
    width: 20px;
    height: 20px;
    margin-left: 10px;
    border: 2px solid #ccc;
    border-top: 2px solid #007bff;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
    vertical-align: middle;
  }

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;

const Input = styled.input`
  width: 300px;
  padding: 0 10px;
  border: 1px solid #ccc;
  border-radius: 7px;
  height: 37px;

  
`;
export const Td3 = styled.td`
  width: 50%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;

  span{
    margin: 0px 5px;
  }

`;

const Select = styled.select`
  width: 250px;
  padding: 0 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  height: 37px;
  margin-left: 5px;
  @media (max-width: 768px) {
    width: 100%;
  }
`;
const Div2 = styled.div`
  display: flex;
  align-items: center;
  justify-content:center;
  
  span{
    padding: 0px  10px;
    color: #575757;
  }
`;





const Grid = ({ showGrid, isLoading, total, dataIni, dataFim, equipamento, modalDetalhesEquipamento }) => {



  //===========================TELA CHEIA==============================//
  const toggleFullscreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen().catch((err) => {
        console.log(`Error attempting to enable full - screen mode: ${err.message}(${err.name})`);
      });
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      }
    }
  };


  const [searchTerm, setSearchTerm] = useState('');
  const [filteredUsers, setFilteredUsers] = useState(equipamento);



  //Input de pesquisa
  const handleSearch = async (term) => {
    try {
      const filtered = equipamento.filter((user) => {
        const equip = (user.COD_EQUIPAMENTO || '').toString().toLowerCase();

        const passaFiltroPesquisa = equip.includes(term.toLowerCase())

        return passaFiltroPesquisa
      });

      setFilteredUsers(filtered);
    } catch (error) {
      console.error("Erro ao pesquisar:", error);
    }

    setCurrentPage(1);
  };

  useEffect(() => {
    handleSearch(searchTerm);
  }, [searchTerm, equipamento]);


  //---------------------------------------------ORDENAÇÂO DA PAGINA-----------------------------------------------------------------//


  //Paginação
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  // Estado para Ordenação
  const [sortConfig, setSortConfig] = useState(null);

  // Função de Ordenação (agora aplicada ANTES da paginação)
  const sortedData = useMemo(() => {
    let sortableData = [...filteredUsers];

    const parseValue = (value) => {
      if (typeof value === 'string') {
        // Remove % se houver, substitui vírgula por ponto, remove espaços
        return parseFloat(value.replace('%', '').replace(',', '.').trim()) || 0;
      }
      return value || 0;
    };

    if (sortConfig !== null) {
      sortableData.sort((a, b) => {
        const aValueRaw = sortConfig.key.split('.').reduce((o, i) => o[i], a);
        const bValueRaw = sortConfig.key.split('.').reduce((o, i) => o[i], b);

        const aValue = parseValue(aValueRaw);
        const bValue = parseValue(bValueRaw);

        if (aValue < bValue) {
          return sortConfig.direction === "ascending" ? -1 : 1;
        }
        if (aValue > bValue) {
          return sortConfig.direction === "ascending" ? 1 : -1;
        }
        return 0;
      });
    }

    return sortableData;
  }, [filteredUsers, sortConfig]);



  //---------------------------------------EFEITO DE PAGINACAO---------------------------------------------------//

  //Paginação
  // Defina a quantidade de itens por página conforme necessário
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = sortedData.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(sortedData.length / itemsPerPage);
  // Função para ir para a próxima página
  const handleNextPage = () => {
    setCurrentPage((prevPage) => Math.min(prevPage + 1, totalPages));
  };

  // Função para ir para a página anterior
  const handlePrevPage = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
  };

  // Função para Alterar Ordenação
  const onColumnClick = (key) => {
    let direction = "ascending";

    if (sortConfig && sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }

    setSortConfig({ key, direction });
  };

  // Função para obter a classe CSS da coluna ordenada
  const getSortClass = (key) => {
    return sortConfig?.key === key ? "sorted-column" : "";
  };

  // Função para exibir o ícone de ordenação (▲ ou ▼)
  const getSortIcon = (key) => {
    if (sortConfig?.key !== key) return "↕"; // Ícone neutro quando não ordenado
    return sortConfig.direction === "ascending" ? "▲" : "▼";
  };







  //=======================GERAR PDF==========================================//

  const getBase64FromImage = (imgSrc) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "Anonymous";

      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = img.naturalWidth;
        canvas.height = img.naturalHeight;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
        resolve({ base64: canvas.toDataURL("image/png"), width: img.naturalWidth, height: img.naturalHeight });
      };

      img.onerror = () => reject(new Error("Erro ao carregar imagem"));
      img.src = imgSrc;
    });
  };


  const gerarPdf = async () => {
    const doc = new jsPDF({ orientation: "landscape", unit: "pt", format: "A4" });

    // Marca d'água
    const { base64: marcaDaguaBase64, width: mw, height: mh } = await getBase64FromImage(logo1);
    const maxMarcaW = 400, maxMarcaH = 300;
    const ratioMarca = Math.min(maxMarcaW / mw, maxMarcaH / mh);
    const marcaW = mw * ratioMarca, marcaH = mh * ratioMarca;
    const centerX = (842 - marcaW) / 2, centerY = (595 - marcaH) / 2;

    // Cabeçalho
    const { base64, width, height } = await getBase64FromImage(logo6);
    const maxW = 200, maxH = 60;
    const ratio = Math.min(maxW / width, maxH / height);
    const displayW = width * ratio, displayH = height * ratio;

    doc.addImage(base64, 'PNG', 20, 10, displayW, displayH);
    doc.setFontSize(12);
    doc.setTextColor(87, 87, 87);
    doc.text("Aceitação CDC - Equipamento", 30, 70);
    doc.text(`Dados base: ${dataIni} á ${dataFim}`, 600, 70);


    // Cabeçalhos
    const headers = [
      "Frota",
      "Qtde. Cargas",
      "Entrada Automática",
      "Cargas Alteradas",
      "Entradas Auto. c/ Alterações",
      "Entradas Manuais",

      "Automática",
      "Aceitação Alteradas",
      "Auto. c/ Alteração",
      "Manual",

    ];

    // Corpo principal
    const body = sortedData.map(item => [
      item.COD_EQUIPAMENTO,
      item.QTDE_CARGAS,
      item.ENTRADA_AUTOMATICA,
      item.ALTERADAS,
      item.ENTRADA_AUTOMATICA_ALT,
      item.ENTRADA_MANUAL,
      item.percentual_automatica,
      item.aceitacao_alteradas,
      item.percentual_automatica_com_alteracao,
      item.percentual_manual,

    ]);

    // Linha total
    total.forEach(item => {
      body.push([
        `Total`,
        item.QTDE_CARGAS,
        item.ENTRADA_AUTOMATICA,
        item.ALTERADAS,
        item.ENTRADA_AUTOMATICA_ALT,
        item.ENTRADA_MANUAL,
        item.percentual_automatica,
        item.aceitacao_alteradas,
        item.percentual_automatica_com_alteracao,
        item.percentual_manual,

      ]);
    });

    // Tabela
    autoTable(doc, {
      head: [headers],
      body: body,
      startY: 80,
      margin: { top: 50, left: 20, right: 20 },
      styles: {
        fontSize: 10,
        cellPadding: 4
      },
      headStyles: {
        fillColor: [7, 99, 51],
        textColor: 255
      },
      didDrawPage: () => {
        doc.setGState(new doc.GState({ opacity: 0.08 }));
        doc.addImage(marcaDaguaBase64, 'JPEG', centerX, centerY, marcaW, marcaH);
        doc.setGState(new doc.GState({ opacity: 1 }));
      }
    });

    doc.save(`cdc_equipamento_${new Date().toLocaleString("pt-BR")}.pdf`);
  };





  const abrirDetalhes = (codEquipamento) => {
    modalDetalhesEquipamento(codEquipamento);
  };

  return (
    <>

      <Geral>
        <div>

          {isLoading ? (
            <LoadingMessage>Carregando dados, por favor aguarde...</LoadingMessage>
          ) : (
            <>


              {showGrid && (

                <>

                  <>
                    <Table>
                      <Thead>
                        <Tr noHover>
                          <CabecalhoTabela colSpan={13}>
                            <HeaderWrapper>
                              <h2 >Equipamento</h2>

                              <Td3 >

                                <Input
                                  type="text"
                                  placeholder="Pesquisar..."
                                  value={searchTerm}
                                  onChange={(e) => setSearchTerm(e.target.value)}
                                />
                                <Select value={itemsPerPage} onChange={(e) => {
                                  const value = e.target.value === "all" ? sortedData.length : parseInt(e.target.value);
                                  setItemsPerPage(value);
                                  setCurrentPage(1); // Resetar para a primeira página sempre que mudar
                                }}>
                                  <option value={10}>10 por página</option>
                                  <option value={50}>50 por página</option>
                                  <option value={100}>100 por página</option>
                                  <option value="all">Todos</option>
                                </Select>


                                <Div2>
                                  <Button2 onClick={handlePrevPage} disabled={currentPage === 1}>
                                    <ImArrowLeft size={20} />
                                  </Button2>
                                  <span><strong>{currentPage}</strong> de <strong>{totalPages}</strong></span>
                                  <Button2 onClick={handleNextPage} disabled={currentPage === totalPages}>
                                    <ImArrowRight size={20} />
                                  </Button2>
                                </Div2>

                              </Td3>

                              <HeaderRight>
                                <IconGroup>
                                  <Button onClick={gerarPdf} title="Exportar PDF">
                                    Exportar PDF
                                  </Button>
                                  <Button onClick={toggleFullscreen} title="Tela cheia">
                                    Tela cheia
                                  </Button>
                                </IconGroup>
                              </HeaderRight>
                            </HeaderWrapper>
                          </CabecalhoTabela>

                        </Tr>
                      </Thead>

                      <Thead hideOnMobile>

                        <TrHead>
                          <Th onClick={() => onColumnClick("COD_EQUIPAMENTO")} className={getSortClass("COD_EQUIPAMENTO")}>
                            Frota: {getSortIcon("COD_EQUIPAMENTO")}
                          </Th>
                          <Th onClick={() => onColumnClick("QTDE_CARGAS")} className={getSortClass("QTDE_CARGAS")}>
                            Qtde. Cargas: {getSortIcon("QTDE_CARGAS")}
                          </Th>
                          <Th onClick={() => onColumnClick("ENTRADA_AUTOMATICA")} className={getSortClass("ENTRADA_AUTOMATICA")}>
                            Entrada Automática: {getSortIcon("ENTRADA_AUTOMATICA")}
                          </Th>
                          <Th onClick={() => onColumnClick("ALTERADAS")} className={getSortClass("ALTERADAS")}>
                            Cargas Alteradas: {getSortIcon("ALTERADAS")}
                          </Th>
                          <Th onClick={() => onColumnClick("ENTRADA_AUTOMATICA_ALT")} className={getSortClass("ENTRADA_AUTOMATICA_ALT")}>
                            Entradas Auto. c/ Alterações: {getSortIcon("ENTRADA_AUTOMATICA_ALT")}
                          </Th>
                          <Th onClick={() => onColumnClick("ENTRADA_MANUAL")} className={getSortClass("ENTRADA_MANUAL")}>
                            Entradas Manuais: {getSortIcon("ENTRADA_MANUAL")}
                          </Th>
                          <Th onClick={() => onColumnClick("percentual_automatica")} className={getSortClass("percentual_automatica")}>
                            Percent. Automática {getSortIcon("percentual_automatica")}
                          </Th>
                          <Th onClick={() => onColumnClick("aceitacao_alteradas")} className={getSortClass("aceitacao_alteradas")}>
                            Aceitação Alteradas {getSortIcon("aceitacao_alteradas")}
                          </Th>
                          <Th onClick={() => onColumnClick("percentual_automatica_com_alteracao")} className={getSortClass("percentual_automatica_com_alteracao")}>
                            Percent. Auto. c/ Alteração {getSortIcon("percentual_automatica_com_alteracao")}
                          </Th>
                          <Th onClick={() => onColumnClick("percentual_manual")} className={getSortClass("percentual_manual")}>
                            Percent. Manual: {getSortIcon("percentual_manual")}
                          </Th>

                          <Th>

                          </Th>

                        </TrHead>
                      </Thead>

                      <colgroup>
                        <col style={{ width: "10%" }} />
                        <col style={{ width: "10%" }} />
                        <col style={{ width: "10%" }} />
                        <col style={{ width: "10%" }} />
                        <col style={{ width: "10%" }} />
                        <col style={{ width: "10%" }} />
                        <col style={{ width: "10%" }} />
                        <col style={{ width: "10%" }} />
                        <col style={{ width: "10%" }} />
                        <col style={{ width: "10%" }} />

                        <col style={{ width: "5%" }} />
                      </colgroup>

                      <Tbody>
                        {currentItems.map((item, i) => (
                          <Tr key={i}>
                            <Td width="auto" data-label="Frota:">{item.COD_EQUIPAMENTO}</Td>
                            <Td width="auto" data-label="Quantidade Cargas:">{item.QTDE_CARGAS}</Td>
                            <Td width="auto" data-label="Entrada Automática:">{item.ENTRADA_AUTOMATICA}</Td>
                            <Td width="auto" data-label="Cargas Alteradas:">{item.ALTERADAS}</Td>
                            <Td width="auto" data-label="Entradas Auto. c/ Alterações:">{item.ENTRADA_AUTOMATICA_ALT}</Td>
                            <Td width="auto" data-label="Entradas Manuais:">{item.ENTRADA_MANUAL}</Td>
                            <Td width="auto" data-label="Percent. Automática:">{item.percentual_automatica}</Td>
                            <Td width="auto" data-label="Aceitação Alteradas:">{item.aceitacao_alteradas}</Td>
                            <Td width="auto" data-label="Percent. Auto. c/ Alteração:">{item.percentual_automatica_com_alteracao}</Td>
                            <Td width="auto" data-label="Percent. Manual:">{item.percentual_manual}</Td>

                            <Td width="auto">
                              <Button onClick={() => abrirDetalhes(item.COD_EQUIPAMENTO)}>
                                Detalhes
                              </Button>
                            </Td>
                          </Tr>
                        ))
                        }
                        {total.map((item, i) => (
                          <Tr key={i}>
                            <Td width="auto" data-label="Frota:"><strong>{item.TOTAL}</strong></Td>
                            <Td width="auto" data-label="Quantidade Cargas:"><strong>{item.QTDE_CARGAS}</strong></Td>
                            <Td width="auto" data-label="Entrada Automática:"><strong>{item.ENTRADA_AUTOMATICA}</strong></Td>
                            <Td width="auto" data-label="Cargas Alteradas:"><strong>{item.ALTERADAS}</strong></Td>
                            <Td width="auto" data-label="Entradas Auto. c/ Alterações:"><strong>{item.ENTRADA_AUTOMATICA_ALT}</strong></Td>
                            <Td width="auto" data-label="Entradas Manuais:"><strong>{item.ENTRADA_MANUAL}</strong></Td>
                            <Td width="auto" data-label="Percent. Automática:"><strong>{item.percentual_automatica}</strong></Td>
                            <Td width="auto" data-label="Aceitação Alteradas:"><strong>{item.aceitacao_alteradas}</strong></Td>
                            <Td width="auto" data-label="Percent. Auto. c/ Alteração:"><strong>{item.percentual_automatica_com_alteracao}</strong></Td>
                            <Td width="auto" data-label="Percent. Manual:"><strong>{item.percentual_manual}</strong></Td>
                            <Td width="auto">

                            </Td>
                          </Tr>
                        ))}
                      </Tbody>


                    </Table>

                  </>


                </>
              )}
            </>
          )}

        </div>

      </Geral >


    </>

  );
};



export default Grid;
